var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var ArrowDown = function (_a) {
    var onClick = _a.onClick, className = _a.className;
    return (_jsx("svg", __assign({ width: '8', height: '5', viewBox: '0 0 8 5', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', onClick: onClick, className: className }, { children: _jsx("path", { d: 'M7.25 0.75L4 4.25L0.75 0.75', stroke: '#17181B', strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }) })));
};
export { ArrowDown };
//# sourceMappingURL=ArrowDown.js.map